import React, { useState, useEffect, useRef } from "react";
import { AllActiveStatusCurrency, GetAllActiveUOM } from "../../../axios";
import { colors } from "../../../configs";
import { Button, FormDropDown, FormTextInput } from "../../../components";

const QuantityForm = ({
  handleModalClose,
  onSubmit,
  budgetDetail,
  noOfRooms,
}) => {
  const [UomDropDown, SetUomDropDown] = useState([]);
  const [currencyDropDown, SetCurrencyDropDown] = useState([]);
  const [loading, setLoading] = useState(false);
  const submitCounter = useRef(0);
  const [formData, setFormData] = useState({
    budgetQuantity: "",
    budgetUOM: "",
    budgetCurrency: "",
    budgetPrice: "",
    actualQuantity: "",
    actualUOM: "",
    actualCurrency: "",
    actualPrice: "",
    noOfRooms: noOfRooms || null,
  });

  // fetch UOM options
  const getAllActiveUOM = () => {
    setLoading(true);
    GetAllActiveUOM()
      .then((res) => {
        const data = res.data.data || [];
        const result = data.map((ele) => ({
          key: ele.id,
          value: ele.id, // primitive
          label: ele.name,
        }));
        SetUomDropDown(result);
      })
      .finally(() => setLoading(false));
  };

  // fetch Currency options
  const getAllActiveCurrency = () => {
    setLoading(true);
    AllActiveStatusCurrency()
      .then((res) => {
        const data = res.data.data || [];
        const result = data.map((ele) => ({
          key: ele.id,
          value: ele.id, // primitive
          label: ele.name,
        }));
        SetCurrencyDropDown(result);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    getAllActiveUOM();
    getAllActiveCurrency();
  }, []);

    const handleChange = (key, optionOrValue) => {
    const value =
      typeof optionOrValue === "object" && optionOrValue !== null
        ? optionOrValue.value
        : optionOrValue;

    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  // derived totals
  const budgetTotalPrice =
    parseFloat((formData.noOfRooms ?? formData.budgetQuantity) || 0) *
    parseFloat(formData.budgetPrice || 0);
  const actualTotalPrice =
    parseFloat(formData.actualQuantity || 0) *
    parseFloat(formData.actualPrice || 0);

  // submit
  const handleSubmit = () => {
  submitCounter.current += 1;
  const budgetQuantityValue =
    formData.budgetQuantity || formData.noOfRooms || 0;

  const payload = {
    ...formData,
    budgetQuantity: budgetQuantityValue,
    budgetTotalPrice: parseFloat(budgetQuantityValue) * parseFloat(formData.budgetPrice || 0),
    actualTotalPrice: parseFloat(formData.actualQuantity || 0) * parseFloat(formData.actualPrice || 0),
  };
  onSubmit && onSubmit(payload, submitCounter.current);
  handleModalClose && handleModalClose();
};


  return (
    <>
      <h1>Quantity List</h1>

      {/* Budget Row 1 */}
      <div className="row">
        <div className="col-md-4">
          <FormTextInput
            type="number"
            label="Budget Quantity"
            placeholder="Enter Budget Quantity"
            Value={(formData.noOfRooms ?? formData.budgetQuantity) || ""}
            onChangeText={(val) => handleChange("budgetQuantity", val)}
            editable={true}
            min={0}
          />
        </div>
        <div className="col-md-4" style={{ marginTop: "15px" }}>
          <FormDropDown
            Label="Budget UOM"
            Options={UomDropDown}
            value={formData.budgetUOM || ""}
            onSelect={(val) => handleChange("budgetUOM", val)}
          />
        </div>
        <div className="col-md-4" style={{ marginTop: "15px" }}>
          <FormDropDown
            Label="Budget Currency"
            Options={currencyDropDown}
            value={formData.budgetCurrency || ""}
            onSelect={(val) => handleChange("budgetCurrency", val)}
          />
        </div>
      </div>

      {/* Budget Row 2 */}
      <div className="row">
        <div className="col-md-6">
          <FormTextInput
            type="number"
            label="Budget Price"
            placeholder="Enter Budget Price"
            Value={formData.budgetPrice || ""}
            onChangeText={(val) => handleChange("budgetPrice", val)}
            editable={true}
          />
        </div>
        <div className="col-md-6">
          <FormTextInput
            type="number"
            label="Budget Total Price"
            Value={budgetTotalPrice}
            editable={false}
          />
        </div>
      </div>

      {/* Actual Row 1 */}
      <div className="row">
        <div className="col-md-4">
          <FormTextInput
            type="number"
            label="Actual Quantity"
            placeholder="Enter Actual Quantity"
            Value={formData.actualQuantity || ""}
            onChangeText={(val) => handleChange("actualQuantity", val)}
            min={0}
            editable={true}
          />
        </div>
        <div className="col-md-4" style={{ marginTop: "15px" }}>
          <FormDropDown
            Label="Actual UOM"
            Options={UomDropDown}
            value={formData.actualUOM || ""}
            onSelect={(val) => handleChange("actualUOM", val)}
          />
        </div>
        <div className="col-md-4" style={{ marginTop: "15px" }}>
          <FormDropDown
            Label="Actual Currency"
            Options={currencyDropDown}
            value={formData.actualCurrency || ""}
            onSelect={(val) => handleChange("actualCurrency", val)}
          />
        </div>
      </div>

      {/* Actual Row 2 */}
      <div className="row">
        <div className="col-md-6">
          <FormTextInput
            type="number"
            label="Actual Price"
            placeholder="Enter Actual Price"
            Value={formData.actualPrice || ""}
            onChangeText={(val) => handleChange("actualPrice", val)}
            editable={true}
          />
        </div>
        <div className="col-md-6">
          <FormTextInput
            type="number"
            label="Actual Total Price"
            Value={actualTotalPrice}
            editable={false}
          />
        </div>
      </div>

      <div className="mt-3">
        <Button
          buttonName="Save"
          buttonStyle={{ backgroundColor: colors.primary }}
          onClick={handleSubmit}
        />
      </div>
    </>
  );
};

export default QuantityForm;
